import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

import { CustomerLogo } from '@shared/components/display/CustomerLogo';
import { useCustomer } from '@contexts/CustomerContext';

interface CheckoutHeaderProps {
  onBackToCart: () => void;
}

export const CheckoutHeader = ({ onBackToCart }: CheckoutHeaderProps) => {
  const { branding } = useCustomer();

  return (
    <Paper variant="checkoutHeader" elevation={0} component="header">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="CheckoutHeader-row"
      >
        <Typography className="CheckoutHeader-title">Almost There! Review Your Order</Typography>

        <IconButton onClick={() => window.open(branding.homepageUrl, '_blank')}>
          <CustomerLogo inheritViewBox className="CheckoutHeader-logo" />
        </IconButton>

        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          useFlexGap
          sx={{ cursor: 'pointer', '&:hover': { opacity: 0.8 } }}
          onClick={onBackToCart}
        >
          <ShoppingCartOutlinedIcon fontSize="medium" className="CheckoutHeader-cartIcon" />
          <Typography className="CheckoutHeader-cartLabel">Go Back To Cart</Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};
